import { render, staticRenderFns } from "./add-order-dialog.vue?vue&type=template&id=9c9163e4&scoped=true&lang=pug&"
import script from "./add-order-dialog.vue?vue&type=script&lang=js&"
export * from "./add-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-order-dialog.vue?vue&type=style&index=0&id=9c9163e4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9163e4",
  null
  
)

export default component.exports